import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class AnalyticsService {
	serviceConfigs = {
		appName: undefined,
		appVersion: undefined,
		GAKey: null,
		printGALogs: false //print ga logs
	};

	constructor() {

		this.setConfigs({
			appName: environment.common.appName,
			appVersion: environment.common.appVersion,
			GAKey: environment.GAKey,
			printGALogs: environment.common.printGALogs //print ga logs
		});

		this.initGA();
	}

	setConfigs(configs) {
		Object.assign(this.serviceConfigs, configs);
	}

	initGA() {
		console.log(">>> starting Google Analytics!", this.serviceConfigs);

		if (!(this.serviceConfigs.GAKey)) {
			console.error("init GA fail! missing GA Key!");
			return false;
		}

		/*script from goolgle analytics api*/
		(function (i, s, o, g, r, a, m) {
			i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function () {
				(i[r].q = i[r].q || []).push(arguments)
			}, i[r].l = 1 * <any>new Date(); a = s.createElement(o),
				m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
		})(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

		(<any>window).ga('create', {
			trackingId: this.serviceConfigs.GAKey,
			cookieDomain: 'auto'
		});

		(<any>window).ga('set', {
			appName: this.serviceConfigs.appName,
			appVersion: this.serviceConfigs.appVersion
		});

		(<any>window).ga('require', 'displayfeatures');//load ga displayfeatures plugin
	}

	log(...args: any[]) {//print to console
		if (this.serviceConfigs.printGALogs) {

			var argsArr = Array.prototype.slice.call(arguments)
			console.log(">>>(ga) ", argsArr);
		}
	}

	setView(moduleName, viewName) {
		var view = '/' + moduleName + '/' + viewName;
		var title = moduleName + ' | ' + viewName;
		this.log("setView:", view);

		(<any>window).ga('set', {
			page: view,
			title: title
		});
	}

	/* track page or view */
	trackView(moduleName, viewName?, subViewName?) {
		var view = moduleName + ((viewName) ? "/" + viewName : "") + ((subViewName) ? " - " + subViewName : "");
		var title = moduleName + ((viewName) ? ' | ' + viewName : "") + ((subViewName) ? " - " + subViewName : "");
		this.log("trackView:", view);
		//window.ga('set', 'page', viewTitle);
		//window.ga('send', 'pageview');
		(<any>window).ga('send', {
			hitType: 'pageview',
			page: view,
			title: title
		});
	}

	/* track events like links button clicks ... */
	trackEvent(category, action, label, value?) {
		this.log("trackEvent: " + category + ", " + action + ((label !== undefined) ? ", " + label : "") + ((value !== undefined) ? ", " + value : ""));

		var sendObj: any = {
			hitType: 'event',
			eventCategory: category,
			eventAction: action
		};

		if (label !== undefined) {//optional
			sendObj.eventLabel = label;
		}

		if (value !== undefined) {//optional
			sendObj.eventValue = value;
		}

		(<any>window).ga('send', sendObj);
	}

}



// WEBPACK FOOTER //
// ./src/app/services/analytics.service.ts